import React from "react";
import "./App.css";
import { Login } from "./components/Login";
import { Cleans } from "./components/Cleans";

function App() {
  const token = localStorage.getItem("token");

  if (token) {
    return <Cleans />
  } else {
    return <Login />;
  }
}

export default App;
